import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { generatePath, useParams } from "react-router";

import { ProjectReviewVisitV2OverviewNavigationItem } from "./ProjectReviewVisitV2OverviewNavigationItem";

type ProjectReviewVisitV2OverviewNavigationProps = {
    panelStatus: Record<"time" | "weather" | "team" | "functions" | "observations", boolean>;
};

export function ProjectReviewVisitV2OverviewNavigation({ panelStatus }: ProjectReviewVisitV2OverviewNavigationProps) {
    const { t } = useTranslation("project");
    const { clientSlug, projectSlug, visitId } = useParams();
    if (!clientSlug || !projectSlug || !visitId) throw new Error("invalid params");

    const basePath = generatePath("/c/:clientSlug/p/:projectSlug/review-visit/:visitId", {
        clientSlug,
        projectSlug,
        visitId,
    });

    return (
        <Stack>
            <ProjectReviewVisitV2OverviewNavigationItem
                checked={panelStatus.time}
                label={t("projectReviewVisitV2.overview.navigationItems.time.label")}
                to={`${basePath}/time-reports`}
            />
            <ProjectReviewVisitV2OverviewNavigationItem
                checked={panelStatus.weather}
                label={t("projectReviewVisitV2.overview.navigationItems.weather.label")}
                to={`${basePath}/weather-reports`}
            />
            <ProjectReviewVisitV2OverviewNavigationItem
                checked={panelStatus.team}
                label={t("projectReviewVisitV2.overview.navigationItems.teamReports.label")}
                to={`${basePath}/team-reports`}
            />
            <ProjectReviewVisitV2OverviewNavigationItem
                checked={panelStatus.functions}
                label={t("projectReviewVisitV2.overview.navigationItems.functions.label")}
                to={`${basePath}/functions`}
            />
            <ProjectReviewVisitV2OverviewNavigationItem
                checked={panelStatus.observations}
                label={t("projectReviewVisitV2.overview.navigationItems.observations.label")}
                to={`${basePath}/observations`}
            />
        </Stack>
    );
}
